
import PropTypes from 'prop-types';
import React from 'react';
import Showdown from 'showdown';

const converter = new Showdown.Converter({
  tables: true,
  simplifiedAutoLink: true,
  strikethrough: true,
  tasklists: true,
});

const propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
  fixedToTop: PropTypes.bool,
  markdownHtml: PropTypes.bool,
  onClose: PropTypes.func,
  type: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
};

class Alert extends React.Component {
  render() {

    let close;

    let classNames = `alert alert-${this.props.type}`;

    if (this.props.fixedToTop) {
      classNames += ' fixed-alert';
    }

    if (this.props.className) {
      classNames += ` ${this.props.className}`;
    }

    if (this.props.onClose) {
      close = <button
        type="button"
        className="close"
        onClick={this.props.onClose}>

        &times;
      </button>;
    }

    let alertMessage = this.props.message;

    if (this.props.markdownHtml) {
      alertMessage = (<div dangerouslySetInnerHTML={{ __html: converter.makeHtml(this.props.message) }} />);
    }

    return (
      <div className={classNames}>
        {close}
        { alertMessage }
      </div>
    );
  }
}

Alert.propTypes = propTypes;


export default Alert;



// WEBPACK FOOTER //
// ./client/components/alert.jsx